
import { Base } from '../base-component';
import Slider from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

import './video-carousel.component.scss';



export class VideoCarousel extends Base {

	sliderContainer: Element;
	sliderPagination: Element;
	sliderConfig: SwiperOptions;
	sliderNext: Element;
	sliderPrev: Element;
	sliderItems: any;
	windowWidth: number;

	constructor(element: Element ) {
		super(element);
	}

	init() {

		this.sliderContainer = this.element.querySelector('.swiper-container');
		this.sliderPagination = this.element.querySelector('.swiper-pagination');
		this.sliderNext = this.element.querySelector('.swiper-button-next');
		this.sliderPrev = this.element.querySelector('.swiper-button-prev');
		this.sliderItems = this.element.querySelectorAll('.video-carousel-item');
		this.windowWidth = document.documentElement.clientWidth;

		this.sliderConfig = {
			preventClicks: false,
			preventClicksPropagation: false,
			slidesPerView: 3,
			spaceBetween: 30,
			initialSlide: 0,
			breakpoints: {
				1200: {
					initialSlide: 0,
					slidesPerView: 2.6,
					spaceBetween: 30,
				},
				768: {
					initialSlide: 0,
					slidesPerView: 2.4,
					spaceBetween: 20,
				},
				576: {
					initialSlide: 0,
					slidesPerView: 1.2,
					spaceBetween: 15,
				}
			},
			pagination: {
				el: this.sliderPagination,
				type: 'bullets',
				clickable: true
			},
			navigation: {
				nextEl: this.sliderNext,
				prevEl: this.sliderPrev,
			}
		};

		Slider.init(this.sliderContainer, this.sliderConfig);

	}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/video-carousel/video-carousel.component.ts